/**
 * Research v2 "new" route — eagerly registers the file route; the page
 * component and its atom/RPC imports are deferred to `new.lazy.tsx` so they
 * load only on this route, never in the always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/flirtmachine/_authenticated/research/v2/new")({});
